import TemplateView from '../../TemplateView'
import {AccessRights} from '../../constants'
import messageResource from '../../messageResource'
import Button from '../../components/Button'
import AssignedTeamDropdownListContainer from '../assignedTeamList/components/AssignedTeamListContainer'
import $ from 'jquery'
import {
    CustomerCPTAssignmentsListContainer,
    ProjectCPTAssignmentsListContainer,
    TaskCPTAssignmentsListContainer
} from '../cptAssignmentsList/components/CPTAssignmentsListContainer'
import {UserTeamAssignmentType} from '../../panels/user/constants'
import {HierarchyLevels, ManagementAssignmentsSelection} from 'constants'
import {customerNameLower, projectNameLower, taskNameLower, userNameLower} from '../../util/pluralizeUtils'

const AccessRightToClassMap = {
    [AccessRights.MANAGE_USERS]: 'manageUsers',
    [AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]: 'modifyTT',
    [AccessRights.EDIT_HIERARCHY]: 'manageScope',
    [AccessRights.GENERATE_MONEY_REPORTS]: 'generateMoneyReports',
    [AccessRights.SUBMIT_TIME_TRACK]: 'submitTT',
    [AccessRights.LOCK_TIME_TRACK]: 'lockTT',
    [AccessRights.MANAGE_PTO_AND_SICK]: 'manageBalances',
    [AccessRights.MANAGE_GENERAL_SETTINGS]: 'generalSettings'
}

export default class PermissionsSectionContent extends TemplateView {
    constructor({
        userRights,
        isPTOEnabled,
        isSickEnabled,
        isTTAEnabled,
        isLTTEnabled,
        isURAEnabled,
        isBTYEnabled,
        teamAssignmentType,
        usersCount,
        managementAssignmentsSelection,
        tasksCount,
        projectsCount,
        customersCount,
    }) {
        super()

        this.params = {
            userRights,
            isPTOEnabled,
            isSickEnabled,
            isTTAEnabled,
            isLTTEnabled,
            isURAEnabled,
            isBTYEnabled,

            teamAssignmentType,
            usersCount,

            managementAssignmentsSelection,
            tasksCount,
            projectsCount,
            customersCount,
        }
    }


    templateHtml() {
        return '<div class="permissions">' +
               '    <div class="manageRightsSection">' +
               '        <div class="title"><%-manageTitle%></div>' +
               '        <div class="permissionLabelContainer manageUsers">' +
               '            <label><%-manageUsers%></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer modifyTT">' +
               '            <label></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer manageScope">' +
               '            <label><%-manageScope%></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer generateMoneyReports">' +
               '            <label><%-generateMoneyReports%></label>' +
               '        </div>' +
               '    </div>' +
               '   <div class="scopeSection">' +
               '        <div class="title"><%-scopeTitle%></div>' +
               '        <div class="teamSection">' +
               '           <div class="subtitle"><%-selectedTeam%></div>' +
               '           <div class="teamSelectionLabel"></div>' +
               '           <div class="users"></div>' +
               '        </div>' +
               '        <div class="scopeOfWorkSection">' +
               '           <div class="subtitle"><%-scopeOfWork%></div>' +
               '           <div class="scopeSelectionLabel"></div>' +
               '           <div class="partScope">' +
               '              <div class="customers"></div>' +
               '              <div class="separator">/</div>' +
               '              <div class="projects"></div>' +
               '              <div class="separator">/</div>' +
               '              <div class="tasks"></div>' +
               '           </div>' +
               '        </div>' +
               '    </div>' +
               '    <div class="otherRightsSection">' +
               '        <div class="title"><%-otherTitle%></div>' +
               '        <div class="permissionLabelContainer submitTT">' +
               '            <label><%-submitTT%></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer lockTT">' +
               '            <label><%-lockTT%></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer manageBalances">' +
               '            <label></label>' +
               '        </div>' +
               '        <div class="permissionLabelContainer generalSettings">' +
               '            <label><%-systemSettings%></label>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            manageUsers: 'access_rights.manage_users',
            manageScope: 'access_rights.edit_hierarchy',
            generateMoneyReports: 'access_rights.generate_money_reports',
            lockTT: 'access_rights.lock_time_track',
            systemSettings: 'access_rights.manage_general_settings',
            submitTT: 'access_rights.submit_time_track',
            manageTitle: 'profile.permissions.management_rights',
            otherTitle: 'profile.permissions.other_rights',
            scopeTitle: 'profile.permissions.scope_of_work',
            selectedTeam: 'profile.permissions.selected_team.title',
            scopeOfWork: 'profile.permissions.scope_of_work.title',
        }
    }

    afterRender() {
        this._updateModifyTTLabel()
        this._updateBalancesRightLabel()
        this._updateLockTTLabel()
        this._updateGenerateMoneyReportsRight()
        this._updateActiveRights()

        const manageUsers = !!this.params.userRights[AccessRights.MANAGE_USERS]
        const submitOtherUsersTT = !!this.params.userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]
        const editHierarchy = !!this.params.userRights[AccessRights.EDIT_HIERARCHY]
        const generateMoneyReports = !!this.params.userRights[AccessRights.GENERATE_MONEY_REPORTS]

        let manageRights

        if (manageUsers && submitOtherUsersTT && editHierarchy && generateMoneyReports) {
            manageRights = ManagementAssignmentsSelection.ALL
        } else if (manageUsers || submitOtherUsersTT || editHierarchy || generateMoneyReports) {
            manageRights = ManagementAssignmentsSelection.SELECTED
        } else {
            manageRights = ManagementAssignmentsSelection.NO
        }

        if (manageRights === ManagementAssignmentsSelection.NO) {
            $('.scopeSection').hide()
        } else {
            $('.scopeSection').show()
            this._updateTeamCount()
            this._updateManagementAssignmentsCounts()
        }
    }

    _updateTeamCount() {
        $('.userProfile_teamList').remove()

        this.teamMenu = new AssignedTeamDropdownListContainer({
            additionalClass: 'userProfile_teamList'
        }).init($('body'))
        this.teamMenu.hide()

        const isAllScopeAssigned = this.params.teamAssignmentType === UserTeamAssignmentType.ALL
        const noAccessToTeamScope = this.params.teamAssignmentType === UserTeamAssignmentType.NO
        const isNoneScopeAssigned = this.params.teamAssignmentType === UserTeamAssignmentType.SELECTED && this.params.usersCount === 0

        if (isAllScopeAssigned) {
            this.showTeamLabel(messageResource.getMessage('profile.permissions.selected_team.all_departments'))
        } else if (noAccessToTeamScope){
            this.showTeamLabel(messageResource.getMessage('profile.permissions.selected_team.no_access'))
        } else if (isNoneScopeAssigned) {
            this.showTeamLabel(messageResource.getMessage('profile.permissions.selected_team.not_selected'))
        } else {
            this.find('.scopeSection .teamSelectionLabel').hide()
            new Button({
                label: this.params.usersCount + " " + userNameLower(this.params.usersCount),
                onClickCb: () => this.teamMenu.showAt(this.find('.teamSection .users'), {
                    my: 'center top',
                    at: 'center bottom',
                    offset: '0px 10px',
                    collision: 'none',
                }),
                additionalClass: 'permissionButton',
            }).init(this.find('.teamSection .users'))
        }
    }

    showTeamLabel(text) {
        const $teamSelectionLabel = this.find('.scopeSection .teamSelectionLabel')
        $teamSelectionLabel.text(text)
        $teamSelectionLabel.show()
    }

    _updateManagementAssignmentsCounts() {
        const $body = $('body')

        const notSelected = this.params.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED
                            && this.params.customersCount === 0
                            && this.params.projectsCount === 0
                            && this.params.tasksCount === 0

        const all = this.params.managementAssignmentsSelection === ManagementAssignmentsSelection.ALL

        const noAccess = this.params.managementAssignmentsSelection === ManagementAssignmentsSelection.NO

        if (all) {
            this.setupScopeSection(false, true, messageResource.getMessage('user.scope_cell.manage_scope.all_selected'))
        } else if (notSelected) {
            this.setupScopeSection(false, true, messageResource.getMessage('user.scope_cell.manage_scope.not_selected'))
        } else if (noAccess) {
            this.setupScopeSection(false, true, messageResource.getMessage('user.scope_cell.manage_scope.no_access'))
        } else {
            this.setupScopeSection(false, true, messageResource.getMessage('user.scope_cell.manage_scope.selected', [
                    this.params.customersCount,
                    customerNameLower(this.params.customersCount),
                    this.params.projectsCount,
                    projectNameLower(this.params.projectsCount),
                    this.params.tasksCount,
                    taskNameLower(this.params.tasksCount)
                ]
            ))

            //TODO CPT assignments list are disabled until counters in CPT editors would be fixed. See AT-3370
            /* this.setupScopeSection(true, false, '')

            $('.userProfile_taskAssignmentsList').remove()
            const taskLabel = this.params.tasksCount + ' ' + taskNameLower(this.params.tasksCount)
            this.$tasksScope = this.find('.scopeOfWorkSection .tasks')

            if (this.params.tasksCount !== 0) {
                this.taskMenu = new TaskCPTAssignmentsListContainer({
                    additionalClass: 'userProfile_taskAssignmentsList',
                    currentCptLevel: HierarchyLevels.TASK,
                }).init($body)
                this.taskMenu.hide()

                this.taskButton = new Button({
                    label: taskLabel,
                    onClickCb: () => this.taskMenu.showAt(this.$tasksScope, {
                        my: 'center top',
                        at: 'center bottom',
                        offset: '0px 10px',
                        collision: 'none',
                    }),
                    additionalClass: 'permissionButton',
                }).init(this.$tasksScope)
            } else {
                this.$tasksScope.text(taskLabel)
            }

            $('.userProfile_projectAssignmentsList').remove()
            const projectLabel = this.params.projectsCount + ' ' + projectNameLower(this.params.projectsCount)
            this.$projectsScope = this.find('.scopeOfWorkSection .projects')

            if (this.params.projectsCount !== 0) {
                this.projectMenu = new ProjectCPTAssignmentsListContainer({
                    additionalClass: 'userProfile_projectAssignmentsList',
                    currentCptLevel: HierarchyLevels.PROJECT,
                }).init($body)
                this.projectMenu.hide()

                this.projectButton = new Button({
                    label: projectLabel,
                    onClickCb: () => this.projectMenu.showAt(this.$projectsScope, {
                        my: 'center top',
                        at: 'center bottom',
                        offset: '0px 10px',
                        collision: 'none',
                    }),
                    additionalClass: 'permissionButton',
                }).init(this.$projectsScope)
            } else {
                this.$projectsScope.text(projectLabel)
            }

            $('.userProfile_customerAssignmentsList').remove()
            const customerLabel = this.params.customersCount + ' ' + customerNameLower(this.params.customersCount)
            this.$customersScope = this.find('.scopeOfWorkSection .customers')

            if (this.params.customersCount !== 0) {
                this.customerMenu = new CustomerCPTAssignmentsListContainer({
                    additionalClass: 'userProfile_customerAssignmentsList',
                    currentCptLevel: HierarchyLevels.CUSTOMER,
                }).init($body)
                this.customerMenu.hide()

                this.customerButton = new Button({
                    label: customerLabel,
                    onClickCb: () => this.customerMenu.showAt(this.$customersScope, {
                        my: 'center top',
                        at: 'center bottom',
                        offset: '0px 10px',
                        collision: 'none',
                    }),
                    additionalClass: 'permissionButton',
                }).init(this.$customersScope)
            } else {
                this.$customersScope.text(customerLabel)
            }
            */
        }
    }

    setupScopeSection(togglePartScope, toggleLabel, labelText) {
        this.find('.scopeSection .scopeSelectionLabel').toggle(true)
        this.find('.scopeSection .partScope').toggle(togglePartScope)
        this.find('.scopeSection .scopeSelectionLabel').text(labelText)
    }

    _updateActiveRights() {
        Object.keys(AccessRightToClassMap).forEach((right) => {
            this._setActiveRight(AccessRightToClassMap[right], !!this.params.userRights[right])
        })
    }

    _setActiveRight(clazz, active) {
        this.find(`.permissionLabelContainer.${clazz}`)
            .toggleClass('rowWithTick', active)
            .toggleClass('active', active)
            .toggleClass('inactive', !active)
    }

    _updateModifyTTLabel() {
        this.find('.modifyTT label').text(
            this.params.isTTAEnabled
            ? messageResource.getMessage('access_rights.modify_and_approve_tt')
            : messageResource.getMessage('access_rights.submit_other_time_track')
        )
    }

    _updateLockTTLabel() {
        this.find('.lockTT').toggle(this.params.isLTTEnabled)
    }

    _updateBalancesRightLabel() {
        const {isSickEnabled, isPTOEnabled} = this.params
        const $container = this.find('.manageBalances')

        let text = ''
        if (isPTOEnabled && isSickEnabled) {
            text = messageResource.getMessage('access_rights.manage_pto_and_sick')
        } else if (isPTOEnabled) {
            text = messageResource.getMessage('access_rights.manage_pto_only')
        } else if (isSickEnabled) {
            text = messageResource.getMessage('access_rights.manage_sick_only')
        } else {
            $container.hide()
        }

        $container.find('label').text(text)
    }

    _updateGenerateMoneyReportsRight() {
        const $container = this.find('.generateMoneyReports')
        $container.toggle(this.params.isBTYEnabled || this.params.isURAEnabled)

        if (!this.params.isBTYEnabled)
            $container.find('label').text(messageResource.getMessage('access_rights.generate_money_reports_only_cost'))
        if (!this.params.isURAEnabled)
            $container.find('label').text(messageResource.getMessage('access_rights.generate_money_reports_only_billing'))
    }
}



// WEBPACK FOOTER //
// ./web/js/userProfile/components/PermissionsSectionContent.js